export default __webpack_public_path__ + "static/media/light-notes.8ac582fb.png";